var React = require('react');

function AngleUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M63.52 351.84a23.94 23.94 0 0 1-33.85 0L7.05 329.33l-.18-.18a23.77 23.77 0 0 1 .18-33.61l96.42-96.15L160 255.86z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M313.13 295.81l-.18-.17L177 160.11a24 24 0 0 0-34-.11l-39.51 39.39L256.33 352a23.94 23.94 0 0 0 33.85 0L313 329.43a23.78 23.78 0 0 0 .13-33.62z","className":"fa-primary","key":2})]);
}

AngleUp.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = AngleUp;

AngleUp.default = AngleUp;
